import axios from "axios";
import { baseURL } from "../config/api";

export const put_DisabledVehicleLocation = async (data: any, uniqeid: string, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}disabledVehicleLocation/UpdateDisabledVehicleLocationAsResponded?uniqeid=${uniqeid}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getDisabledVehicleLocationByUniqidForShareLocation = (uniqeid: string, tenantId: string) => {
    return getFetch(`disabledVehicleLocation/GetDisabledVehicleLocationByUniqidForShareLocation?uniqeid=${uniqeid}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}
